import { createFileRoute } from '@tanstack/react-router'
import { ReportsListPage } from '@/features/reports/components/ReportsListPage'

export const Route = createFileRoute('/_auth/reports/list')({
  component: ReportsListRoute,
})

function ReportsListRoute() {
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold mb-6 uppercase tracking-wide">
        Reports - List
      </h1>
      <ReportsListPage />
    </div>
  )
}
